interface Props {
  className?: string;
  children: JSX.Element[];
}

export const BoxPanel: React.FC<Props> = ({ className, children }) => {
  const classes = `flex flex-row border rounded-xl border-gray-light bg-gray ${className}`;

  return <div className={classes}>{children}</div>;
};
